"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposureService = void 0;
var axios_1 = require("axios");
var ExposureService = /** @class */ (function () {
    function ExposureService(config, siteToken) {
        this.siteToken = siteToken;
        this.transport = axios_1.default.create({
            withCredentials: true,
            baseURL: config.EXPOSURE_SERVICE_BASE_URL,
        });
    }
    ExposureService.prototype.getShouldAskQuestion = function (questionId) {
        return this.transport
            .get("f/" + questionId + "?siteToken=" + this.siteToken)
            .then(function (response) { return response.data.payload; })
            .catch(function (e) {
            var _a;
            if (((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) === 401 &&
                window.location.protocol === 'http:') {
                console.warn('ATTENTION! If server complains on missing xsrf token (401 error) this is most probably because you are opening site over non-secure connection.\n' +
                    'Find more information on how this can be fixed — in comment section below code where this warning is called');
                // Support of HTTPS protocol locally should be implemented in this task: https://jira.wixpress.com/browse/AF-237
                // Meanwhile as a workaround you can uncheck `secure` flag for `XSRF-TOKEN` cookie
                // in Application —> Cookies tab in dev tools
            }
            throw e;
        });
    };
    return ExposureService;
}());
exports.ExposureService = ExposureService;
//# sourceMappingURL=exposure-service.js.map